import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    formGroup: {
      marginTop: theme.spacing(4),
    },
    formLabel: {
      background: '#f3f3f3',
      padding: theme.spacing(2),
    },
    accordionSummary: {
      background: theme.palette.background.default,
    },
    containButton: {
      '& > *': {
        margin: `5px 10px`,
      },
    },
    submitContainer: {
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.grey[300]}`,
    },
    hiddenRow: {
      display: 'none',
    },
  }));